# GraphQL fragment to get basic info about a step template
# within the sales automation environment.

#import "../fragments/sales-automation-stage-goal.graphql"

mutation UpdateGoal($goal: UpdateGoalInputFieldInput!) {
    updateGoal(input: {goal: $goal}) {
        goal {
            ...SalesAutomationStageGoal
        }
    }
}
